import { useAuthStoreShallow } from "../store/authentication.store";

// Import is an Admin and Creator capability (PRD P0-1). `isCreator` already
// covers org admins; users and creator-lite users are excluded.
export const useCanImportFiles = (): boolean =>
  useAuthStoreShallow((s) => s.isCreator || s.isAdministrator || s.isAdmin);
